<template>

  <div class="sugerencias">
    <div class="container">

      <v-card>
        <v-card-subtitle class="filter-card-header">
          <h2>
            <center>
              Filtros de búsqueda
              <v-btn icon
                @click="filterCardShow = !filterCardShow; "
              >
                <v-icon>{{ filterCardShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
          </center>
          </h2>
        </v-card-subtitle>

        <v-card-text v-if="filterCardShow">

          <v-subheader class="filter-card-subheader">
            <h3> Rango de fechas: </h3>
          </v-subheader>
          <!-- Filtro calendario-->
          <v-row>
            <v-col class="px-4">
              <v-menu
                v-model="minDatePickerActivator"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="200px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="minDateFilter"
                    label="Sugerencias desde"
                    prepend-icon="fa fa-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>

                  <v-date-picker 
                    v-model="minDateFilter" 
                    locale='es' 
                    first-day-of-week=1 
                    @input="minDatePickerActivator = false">
                  </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="px-4">
              <v-menu
                v-model="maxDatePickerActivator"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="200px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="maxDateFilter"
                    label="Sugerencias hasta"
                    prepend-icon="fa fa-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>

                  <v-date-picker 
                    v-model="maxDateFilter" 
                    locale='es' 
                    first-day-of-week=1 
                    @input="maxDatePickerActivator = false">
                  </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        <v-divider></v-divider>

        <!-- Filtro onlyNotRead-->
        <v-row>
          <v-col class="px-4" style="padding-bottom: 0em">
            <v-switch
              v-model="onlyNotRead"
              label="Mostrar sólo no leídos"
            ></v-switch>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="px-4">
            <v-select
                label="Sentimiento"
                style="width: 10em"
                v-model="emotionSelected"
                :items="emotionElements"
                prepend-icon="fa fa-smile"
            >
            </v-select>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-subheader class="filter-card-subheader">
          <h3> Distancia de las sugerencias: </h3>
        </v-subheader>
          <!-- Filtro distancia-->
          <v-switch
            v-model="filterByDistance"
            label="Utilizar filtro por distancia"
            hide-details
          ></v-switch>

          <v-row>
            
            <v-col class="px-4">
              <v-range-slider
                v-model="range"
                :max="maxDistance"
                :min="minDistance"
                hide-details
                class="align-center"
                @end="onSliderEnd"
                :disabled="!filterByDistance"
              >
                <template v-slot:prepend>
                  <v-text-field
                    :value="range[0]"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 4.2em"
                    @change="$set(range, 0, $event)"
                    suffix="km"
                  ></v-text-field>
                </template>
                <template v-slot:append>
                  <v-text-field
                    :value="range[1]"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 4.2em"
                    @change="$set(range, 1, $event)"
                    suffix="km"
                  ></v-text-field>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>

          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn class="SubmibButton toolbar-button" color="" text @click="gabinosFilter">
              Aplicar filtros
            </v-btn> -->
          </v-card-actions>
        </v-card-text>
      </v-card>

        <v-card style="margin-top: 20px">
            <v-card-subtitle class="filter-card-header">
            <h2>
                <center>
                Nube de palabras
                    <v-btn icon
                        @click="wordCloudCardShow = !wordCloudCardShow"
                    >
                        <v-icon>{{ wordCloudCardShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                </center>
            </h2>
            </v-card-subtitle>
            <v-card :loading="!wordCloudImg" v-if="wordCloudCardShow">
                <center>
                    <img class="workcloud-img" v-if="wordCloudImg" style='display:block; width:75%;height:75%;max-height:500px;max-width:500px' id='base64image'
                    :src=wordCloudImg />
                    <v-card-subtitle v-else>Cargando...</v-card-subtitle>
                </center>
            </v-card>
        </v-card>

      <div class="row justify-content-center mb-5">
        <div class="col-md-4"></div>
        </div>
      <v-card
        class="mx-auto"
        :loading="loading"
      >
        <DialogBox ref="resultDialog"></DialogBox>
        <DialogBox ref="confirmationDialog"></DialogBox>
        <template>
          <v-row justify="center">
            <v-dialog v-model="dialog" width="500px">
              <v-card>
                <v-card-title>
                  <v-list-item-avatar>
                    <v-img :src="selectedElement.avatar"></v-img>
                  </v-list-item-avatar>
                  <span class="headline">{{ selectedElement.name }}</span>
                  <v-list-item-icon>
                    <i v-if="selectedElement.positivo" class="fas fa-smile colorPos"></i>
                    <i v-else class="fas fa-frown colorNeg"></i>
                  </v-list-item-icon>
                </v-card-title>
                <hr>
                <v-card-title>
                  <span class="headline">{{ selectedElement.asunto }}</span>
                </v-card-title>
                <v-card-text>{{ selectedElement.cuerpo }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="deleteItemConfirmation()">Eliminar</v-btn>
                  <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
        <v-toolbar
            class="toolbars"
            dark
            style="margin-top: -20px"
        >
          <v-toolbar-title v-if="!search">Sugerencias</v-toolbar-title>

          <v-spacer v-if="!search"></v-spacer>
          <v-btn v-if="!search" icon @click="search = true">
            <i class="fa fa-search" aria-hidden="true"></i>
          </v-btn>
          <v-text-field
            v-on:keyup.esc="searchKey = ''; search = false;"
            v-if="search"
            v-model="searchKey"
            placeholder="Buscar sugerencias por persona"
            prepend-icon="fa fa-search"
            :autofocus="true"
            :dense="true"
            @focusout="handleFocusOut"
          ></v-text-field>
          <v-btn v-if="search" icon @click="searchKey = ''; search = false;">
            <i class="fa fa-window-close" aria-hidden="true"></i>
          </v-btn>
        </v-toolbar>

        <v-list three-line>
          <template v-for="(item, index) in sugerenciasShown">
            <v-subheader
                    v-if="item.header"
                    :key="item.header"
                    v-text="item.header"
            ></v-subheader>

            <v-divider
                    v-else-if="item.divider"
                    :key="index"
                    :inset="item.inset"
            ></v-divider>

            <v-list-item
                    v-else
                    :key="item.title"
                    @click="openItem(item)"
            >
              <v-list-item-avatar>
                <v-img :src="item.avatar"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-html="item.name"></v-list-item-title>
                <v-list-item-subtitle v-html="item.asunto"></v-list-item-subtitle>
                <div class="d-flex d-sm-none mobile-details">
                  <v-list-item-subtitle >A {{Math.ceil(item.distance)}} km</v-list-item-subtitle>
                </div>  
                <div class="d-flex d-sm-none">
                  <v-list-item-subtitle v-html="item.formattedDate"></v-list-item-subtitle>
                </div>  
              </v-list-item-content>

              
              <v-list-item-content class="d-none d-sm-flex">
                <v-list-item-subtitle >desde {{ item.address }}</v-list-item-subtitle>
                <v-list-item-subtitle >a {{Math.ceil(item.distance)}} km</v-list-item-subtitle>
                <v-list-item-subtitle v-html="item.formattedDate"></v-list-item-subtitle>
              </v-list-item-content>

              <!-- Iconos final elemento -->
              <v-list-item-icon>
                  <i v-if="item.leido" class="far fa-comment-alt"></i>
                  <i v-else class="fas fa-comment-alt"></i>
              </v-list-item-icon>
              <v-list-item-icon>
                  <i v-if="item.positivo" class="fas fa-smile colorPos"></i>
                  <i v-else class="fas fa-frown colorNeg"></i>
              </v-list-item-icon>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
    </div>
  </div>
</template>


<script>
/* eslint-disable no-console */
// @ is an alias to /src
import DialogBox from '../components/DialogBox';
import { DB } from '../firebase/db';
var moment = require('moment');
var axios = require('axios').default
moment.locale('es')

export default {
  name: 'sugerencias',
  data: () => ({
      loading: '#9FEDD7',
      elements: [],
      sugerenciasShown: [],
      dialog: false,
      search: false,
      searchKey : undefined,
      selectedElement : {},
      selectedElementIndex: -1,
      sugerenciasUnsub: null,
      filterCardShow: false,
      wordCloudCardShow: false,
      minDistance: 0,
      maxDistance: 700,
      range: [0, 30],
      onlyNotRead: false,
      minDatePickerActivator: false,
      maxDatePickerActivator: false,
      filterByDistance: false,
      minDateFilter: moment().subtract(1, 'month').format("YYYY-MM-DD"),
      maxDateFilter: moment().format("YYYY-MM-DD"),
      emotionElements: ["Cualquiera", "Positivos", "Negativos"],
      emotionSelected: "Cualquiera",
      wordCloudImg: null
    }),

    components: {
      DialogBox
    },

    watch: {
        searchKey : function(searchKey){ this.updateShownElements(searchKey, this.onlyNotRead, this.range, this.emotionSelected) },
        onlyNotRead : function(onlyNotRead){ this.updateShownElements(this.searchKey, onlyNotRead, this.range, this.emotionSelected) },
        filterByDistance: function(){ this.updateShownElements(this.searchKey, this.onlyNotRead, this.range, this.emotionSelected) },
        emotionSelected: function(){ this.updateShownElements(this.searchKey, this.onlyNotRead, this.range, this.emotionSelected) },
        minDateFilter: function(){ this.updateSugerenciasListener() },
        maxDateFilter: function(){ this.updateSugerenciasListener() },
    },

    created () {
      this.$emit('updateTitle', 'Sugerencias');
      this.updateSugerenciasListener()
      window.bus.$emit('menu/activarMenu');
    },

    methods: {

        updateSugerenciasListener() {
            console.log('updateSugerenciasListener')
            if(this.sugerenciasUnsub != null) this.sugerenciasUnsub()
            this.loading = true
            this.elements.splice(0)
            this.sugerenciasUnsub = DB.collection('sugerencias').where('date', '>=' , moment(this.minDateFilter).valueOf())
                                                                .where('date', '<=' , moment(this.maxDateFilter).add(23, 'h').add(59, 'm').add(59, 's').valueOf())
                                                                .orderBy('date', 'desc')
                                                                .onSnapshot(this._onSugerenciasChangeHandler)
        },

        _onSugerenciasChangeHandler(snapshot) {
            snapshot.docChanges().forEach( change => {

                switch (change.type) {
                    case "added":

                        var element = {...change.doc.data()}
                        element.formattedDate = moment.duration(moment(change.doc.data().date).valueOf() - moment().valueOf(), 'milliseconds').humanize(true),
                        element.id = change.doc.id

                        this.elements.push(element);
                        break;

                    case "modified":
                        var index = -1;
                        for (let i = 0; i < this.elements.length; i++) {
                            if(this.elements[i].id == change.doc.id)
                            {
                                index = i;
                                break;
                            }
                        }
                        if(index != -1) {
                            this.elements[index].leido = element.leido;
                        }
                        break;

                    case "removed":
                        index = -1;
                        for (let i = 0; i < this.elements.length; i++) {
                            if(this.elements[i].id == change.doc.id)
                            {
                                index = i;
                                break;
                            }
                        }
                        if(index != -1){
                            this.elements.splice(index, 1);
                        }
                        break;
                }
            });

            this.elements.sort((a, b) => {
                return b.date - a.date;
            });
            this.updateShownElements(this.searchKey, this.onlyNotRead, this.range, this.emotionSelected)
            this.loading = false
        },

        updateShownElements(searchKey, noLeidos, rangoDistancia, emotion) {
            console.log('updateShownElements')
            this.wordCloudImg = null
            this.sugerenciasShown.splice(0);

            var tempSugerencias = this.elements

            if(searchKey) {
                tempSugerencias = tempSugerencias.filter( sugerencia => sugerencia.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(searchKey.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")))
            }

            if(noLeidos) {
                tempSugerencias = tempSugerencias.filter( sugerencia => sugerencia.leido == false)
            }

            if(rangoDistancia && this.filterByDistance) {
                tempSugerencias = tempSugerencias.filter( sugerencia => {
                    if(sugerencia.distance) {
                        return (sugerencia.distance >= rangoDistancia[0] && sugerencia.distance <= rangoDistancia[1])
                    }
                    else {
                        return true
                    }
                })
            }

            if(emotion && emotion !== "Cualquiera") {
                tempSugerencias = tempSugerencias.filter( sugerencia => {
                    if(emotion === "Positivos") {
                        return sugerencia.positivo
                    }

                    if(emotion === "Negativos") {
                        return !sugerencia.positivo
                    }

                    return true
                })
            }

            tempSugerencias.forEach( sugerencia => {
                this.sugerenciasShown.push(sugerencia)
            })

            this.sugerenciasShown.sort((a, b) => {
                return b.date - a.date;
            });

            this.getWordCloud()
        },

        async getWordCloud() {

            const data = {
                sugerencias: []
            }

            data.sugerencias = this.sugerenciasShown.map( sugerencia => sugerencia.cuerpo)

            const base64Image = (await axios.put('https://europe-west1-buzon-ayuntamiento.cloudfunctions.net/getWordCloud', data)).data
            this.wordCloudImg = 'data:image/png;base64,' + base64Image
        },

        openItem(element) {
            this.selectedElement = element;
            this.selectedElementIndex = this.elements.indexOf(element);
            this.dialog = true;

            if(!element.leido){
            element.leido = true;

            let item = {
                date : element.date,
                asunto : element.asunto,
                avatar : element.avatar,
                cuerpo : element.cuerpo,
                leido : element.leido,
                positivo : element.positivo,
                name : element.name,
            };

            DB.collection('sugerencias').doc(element.id).update(item).catch(error => {
                console.error(error);
                this.errorDialog("Se ha producido un error al modificar un elemento en la base de datos.");
            })
            }
        },

        deleteItemConfirmation() {
            this.$refs.confirmationDialog.show('warning', 
            `¿Está seguro que quiere eliminar esta sugerencia de ${this.selectedElement.name}?`,
            true,
            this.deleteItem);
        },

        deleteItemSuccess() {
            this.$refs.resultDialog.show('info', "Sugerencia eliminada con éxito.", false);
        },

        errorDialog(error) {
            this.$refs.resultDialog.show('error', error + " Compruebe la conexión a Internet. Si el problema persiste contacte con el administrador.", false);
        },

        deleteItem() {

            return new Promise((resolve, reject) => {
            DB.collection('sugerencias').doc(this.selectedElement.id).delete()
            .then( () => {
                this.elements.splice(this.selectedElementIndex, 1);
                this.deleteItemSuccess();
                this.dialog = false;
                resolve();
            })
            .catch(error => {
                console.error(error);
                this.errorDialog("Se ha producido un error al eliminar el elemento en la base de datos.")
                reject(error)
            })
            })

        },

        handleFocusOut() {
            if(this.searchKey == '')
            this.search = false;
        },

        onSliderEnd() {
            this.updateShownElements(this.searchKey, this.onlyNotRead, this.range, this.emotionSelected)
        }
    }
}
</script>

<style scoped>
.filter-card-header {
  padding-top: 2em;
  padding-left: 3em;
}

.filter-card-subheader {
  padding-top: 1.5em;
}

.mobile-details {
  margin-top: 0.4em;
}

</style>